import { render } from "./messagebox.vue?vue&type=template&id=38cf7eda"
import script from "./messagebox.vue?vue&type=script&lang=js"
export * from "./messagebox.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__